import React from 'react';
import { compiler } from 'markdown-to-jsx';
import { useTranslation } from 'react-i18next';
import { Copy } from '@honda-canada/design-system-react';
import RoutableSitecoreLink from '../../RoutableSitecoreLink';
import { useAppName } from '../../../utils/sitecoreContext';
import themeStyles from './styles/AvailabilityDisclaimer.styles';
const Link = themeStyles.apply(RoutableSitecoreLink, 'Link');
const AvailabilityDisclaimer = ({ dealerName, contactDealerLink }) => {
    const { t } = useTranslation();
    const appName = useAppName();
    const disclaimer = t('Shared.Common.availabilityDisclaimerText', {
        contactDealerLink: `<Link>${t('Shared.Common.contactDealerLabel', { dealerName })}</Link>`,
    });
    return (React.createElement(Copy, { mb: ['m', 'm', 'default'], size: "regular", "data-testid": "cy-inventory-status-disclaimer" }, compiler(disclaimer, {
        overrides: {
            Link: {
                component: Link,
                props: {
                    variant: appName,
                    field: {
                        value: { href: contactDealerLink, linktype: 'external', target: '_blank' },
                    },
                    'data-testid': 'cy-inventory-status-disclaimer-contact-dealer',
                    ariaLabel: t('Shared.Common.disclaimerContactDealerAria', { dealerName }),
                },
            },
        },
    })));
};
export default AvailabilityDisclaimer;
